var map = {
	"./symbol_0.png": "f9bf",
	"./symbol_1.png": "8bf6",
	"./symbol_2.png": "d821",
	"./symbol_3.png": "36fa",
	"./symbol_4.png": "6fc3",
	"./symbol_5.png": "20b4",
	"./symbol_6.png": "06f89",
	"./symbol_7.png": "c38c",
	"./symbol_8.png": "c1c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1092";